export default "__VITE_ASSET__Cuobh7k0__"